export const truncateTimeToSeconds = (totalTimeMs: number) => {
  const timeDivision = totalTimeMs / 1000;
  const decimalPortion = timeDivision % 1;
  const roundDecimalPortion = Math.round(decimalPortion * 1000);
  return totalTimeMs - roundDecimalPortion;
};
